import { render, staticRenderFns } from "./form-files.vue?vue&type=template&id=3186b938&"
import script from "./form-files.vue?vue&type=script&lang=js&"
export * from "./form-files.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports